import { ArrayLayoutProps, ControlElement, isPrimitiveArrayControl, RankedTester, rankWith } from "@jsonforms/core";
import { withJsonFormsArrayLayoutProps } from "@jsonforms/react";

import ArrayRendererMain from "../ArrayRenderer/ArrayRenderer";

interface CustomArrayLayoutProps extends ArrayLayoutProps {
	uischema: {
		subText?: string;
		headingLevel?: number;
	} & ControlElement;
}

export const PrimitiveArrayLayoutRenderer = (props: CustomArrayLayoutProps) => <ArrayRendererMain {...props} />;

export const primitiveArrayLayoutTester: RankedTester = rankWith(4, isPrimitiveArrayControl);

export default withJsonFormsArrayLayoutProps(PrimitiveArrayLayoutRenderer);
